<template>
  <div class="box">
    <article class="media">
      <div class="media-content">
        <div :id="chartId" style="width:100%; height:300px;" class="has-text-centered"></div>
        <br />
        <div class="has-text-centered">
          <h5>
            <b>{{ this.title }}</b>
          </h5>
        </div>
      </div>
    </article>
  </div>
</template>
<script>
export default {
  props: {
    data: { type: Number, required: true },
    title: { type: String },
    name: { type: String, default: 'default' }
  },
  data() {
    return {
      chartElement: null
    }
  },
  computed: {
    chartId() {
      return `donut-chart-${this.name}`
    }
  },
  mounted() {
    this.chartElement = window.echarts.init(document.getElementById(this.chartId))
    this.loadChartData(this.data)
    this._resizeHandler = () => {
      this.chartElement.resize()
    }
    window.addEventListener('resize', this._resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._resizeHandler)
  },
  methods: {
    loadChartData(data) {
      const a = data * 100
      const b = 100 - a
      const label = `%${Math.round(a)}`

      const options = {
        // tooltip: {
        //   trigger: 'item',
        //   formatter: '{a} <br/>{b}: {c} ({d}%)',
        // },
        series: [
          {
            name: this.title,
            type: 'pie',
            radius: ['50%', '80%'],
            avoidLabelOverlap: true,
            label: {
              color: '#000',
              fontSize: '200%',
              position: 'center',
              formatter: () => label
            },
            labelLine: {
              show: false
            },
            data: [
              { value: b, itemStyle: { color: '#dd2248' } },
              { value: a, itemStyle: { color: '#3ec154' } }
            ]
          }
        ]
      }
      this.chartElement.setOption(options)
    }
  },
  watch: {
    data(newData) {
      if (newData && this.chartElement) {
        this.loadChartData(newData)
      }
    }
  }
}
</script>
